export const es = {
  // customMessage: 'Hola mundo'
}



// WEBPACK FOOTER //
// ./src/customization/GlobalBPOCore/lang/es.js